// extracted by mini-css-extract-plugin
module.exports = {"iconRoomy":"judge-shell-topbar_iconRoomy__kQ6Th","wordmarkRoomy":"judge-shell-topbar_wordmarkRoomy__75AAA"};